import { useEffect } from "react";
import axios from "axios";
import { applyTheme } from "./themeConfig";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Fetches the saved theme and applies it to the public site. Renders nothing.
export const ThemeProvider = () => {
  useEffect(() => {
    axios.get(`${API}/theme`).then((r) => applyTheme(r.data)).catch(() => {});
  }, []);
  return null;
};
